import { useEffect, useState } from "react";

// componentes react bootstrap
import {
  Form,
  Button,
  Modal,
  Container,
  Collapse,
  Row,
  Col,
} from "react-bootstrap";

// components
import Alertas from "../../../common/Alertas";
import GruposSubgrupos from "../../combos/GruposSubgrupos";
import setDatosGrupos from "../../../../services/grupos/setDatos";
import { usePermisions } from "../../../../hooks/usePermisions";

// combos
import { TipoFuente } from "../../combos/TipoFuente";
import { TipoLicencia } from "../../combos/TipoLicencia";
import { TerminosCondiciones } from "../../combos/TerminosCondiciones";
import Tematicas from "../../combos/Tematicas";
import Dependencias from "../../combos/Dependencias";
import SoftwareUtilizado from "../../combos/SoftwareUtilizado";
import { ReactSelect } from "../../../common/ReactSelect";

// files upload
import { DropZoneFile } from "../DropZoneFile";

// icons
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { AiOutlinePicture } from "react-icons/ai";

// http services
import getDatos from "../../../../services/getDatos";
import setDatos from "../../../../services/setDatos";
import updateDatos from "../../../../services/updateDatos";
import generarFilesOpenData from "../../../../services/generarFilesOpenData";

// Variables globales
import { URL_IMAGE_GEOMEDELLIN } from "../../../../environment";
import Load from "../../../common/Load";

export const AdminDatoAbierto = ({
  caractFiltro,
  idComponente,
  show,
  onHide,
  tituloModal,
  accion,
  objectEditarDatoAbierto = null,
  buscar,
}) => {
  const [loadVisible, setLoadVisible] = useState(false);

  const { permissions, infoUser } = usePermisions(idComponente);

  // state Name file edit
  const [nameFileFormato, setNameFileFormato] = useState([]);

  const [diasFrecuencia, setDiasFrecuencia] = useState([]);

  // state file upload
  const [fileUpload, setfileUpload] = useState(null);

  // state ruta img dato abierto
  const [rutaImg, setRutaImg] = useState("");

  // state fuente colaborativo
  const [fuenteColaborativoObject, setFuenteColaborativoObject] = useState({});

  // state info metadato
  const [metadatos, setMetadatos] = useState([]);

  // state combo servicio
  const [servicios, setServicios] = useState([]);

  const [tipofiltroSubGruposFiltrada, setTipofiltroSubGruposFiltrada] =
    useState([]);

  // state formatos data
  const [formatosChecks, setFormatosChecks] = useState([]);

  // data dato abierto
  const [dataDatoAbierto, setDataDatoAbierto] = useState({
    idFuenteDato: null,
    idMetadato: null,
    nombreMetadato: "",
    uuidGeonetWork: "",
    imgOpenData: "",
    descripcion: "",
    fecha_actualizacion: "",
    tipoFuente: null,
    tipoLicencia: null,
    tematicaDatoAbierto: null,
    dependenciaDatoAbierto: null,
    terminosCondDatoAbierto: null,
    prioridadDatoAbierto: "",
    tieneServicio: false,
    consumible: false,
    servicioDatoAbierto: null,
    urlServicioDatoAbierto: "",
    diasDatosAbierto: 0,
    formatosDatosAbiertos: false,
    formatos: [],
    fuenteColaborativoData: fuenteColaborativoObject,
    activo: false,
    destacado: false,
    calificacion: false,
    colaborativo: false,
    idUsuario: infoUser,
    deleteChecks: [],
    grupos: [],
    subgrupos: [],
  });
  // state files
  const [filesFormatos, setFilesFormatos] = useState([]);

  const handleClickInputFileFormato = ({ target }) => {
    document.getElementById(`input-file_formatos_${target.value}`).click();
  };

  // handle change
  const handleChange = ({ target }) => {
    const { name, value, type, checked } = target;

    if (name === "tieneServicio" && !checked) {
      setFilesFormatos([]);

      setNameFileFormato([]);

      setDataDatoAbierto((prev) => ({
        ...prev,
        formatos: [],
      }));
    }

    setDataDatoAbierto((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleChangePrioridad = ({ target }) => {
    if (/^-?\d*$/.test(target.value)) {
      if (target.value != "" && target.value < 1) {
        setDataDatoAbierto((prev) => ({
          ...prev,
          [target.name]: target.type === "checkbox" ? target.checked : 1000,
        }));
      } else {
        setDataDatoAbierto((prev) => ({
          ...prev,
          [target.name]:
            target.type === "checkbox" ? target.checked : target.value,
        }));
      }
    }
  };

  // handle change react select
  const handleChangeReactSelect = ({ value, label }, { name }) => {
    if (name === "idMetadato") {
      const infoMetadato = metadatos.filter(
        (metadato) => metadato.id === value
      );

      setDataDatoAbierto((prev) => ({
        ...prev,
        idMetadato: value,
        nombreMetadato: infoMetadato[0].nombreMetadato,
        imgOpenData: infoMetadato[0].imagenMetadato,
        uuidGeonetWork: infoMetadato[0].uuid,
        descripcion: infoMetadato[0].descripcionMetadato,
        fecha_actualizacion: infoMetadato[0].fecha_actualizacion,
      }));

      setRutaImg(infoMetadato[0].imagenMetadato);

      return;
    }

    if (name === "servicioDatoAbierto") {
      const infoServicio = servicios.filter(
        (servicio) => servicio.id_servicio === value
      );

      setDataDatoAbierto((prev) => ({
        ...prev,
        urlServicioDatoAbierto: infoServicio[0]?.servicio,
        [name]: value,
      }));

      return;
    }

    setDataDatoAbierto((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // handle change collapse fuente colaborativo
  const handleChangeFuenteColabo = ({ target }) => {
    setFuenteColaborativoObject((prev) => ({
      ...prev,
      [target.name]: target.value,
    }));
  };

  // handle change data datos abierto and fuente colaborativo
  const handleChangeColaborativo = ({ target }) => {
    setDataDatoAbierto((prev) => ({
      ...prev,
      [target.name]: target.checked,
      fuenteColaborativoData: !target.checked ? {} : fuenteColaborativoObject,
    }));
  };

  // handle change formato
  const handleFormatos = () => {
    setDataDatoAbierto((prev) => ({
      ...prev,
      formatosDatosAbiertos: !dataDatoAbierto.formatosDatosAbiertos,
      formatos: !dataDatoAbierto.formatosDatosAbiertos
        ? []
        : [...dataDatoAbierto.formatos],
    }));
  };

  // handle change file
  const handleFileUpload = (file) => {
    setfileUpload(file);
  };

  // handle change arrays
  const handleChangeFormatosChecks = ({ target }) => {
    let arrayData = dataDatoAbierto.formatos;

    if (target.checked) {
      arrayData.push(String(target.value));
    } else {
      arrayData = arrayData.filter((item) => item !== String(target.value));
    }

    setDataDatoAbierto((prev) => ({
      ...prev,
      formatos: [...arrayData],
    }));
  };

  const handleChangeFormatoFile = (e, idFormato) => {
    try {
      document.getElementById(`label-formato_file_${idFormato}`).innerHTML =
        e.target.files[0].name;

      let arrayObjectFileFormatos = [...filesFormatos];

      let arrayObjectNameFileFormato = [...nameFileFormato];

      arrayObjectFileFormatos = arrayObjectFileFormatos.filter(
        (file) => file.idFormato !== idFormato
      );

      arrayObjectNameFileFormato = arrayObjectNameFileFormato.filter(
        (nameFile) => nameFile.idFormato !== idFormato
      );

      arrayObjectFileFormatos.push({ idFormato, file: e.target.files[0] });

      arrayObjectNameFileFormato.push({
        idFormato,
        nameFile: e.target.files[0].name,
      });

      setFilesFormatos(arrayObjectFileFormatos);

      setNameFileFormato(arrayObjectNameFileFormato);
    } catch (error) {
      return false;
    }
  };

  const listarNombreMetadato = async () => {
    const metadatos = await getDatos("opendata/metadatos");
    setMetadatos(metadatos);
  };

  const listarCombos = async () => {
    const data = await getDatos("atributos/datoabiertocombos");
    setServicios(data.resultServicios);
    setDiasFrecuencia(data.resultDias);
  };

  const listarFormatos = async () => {
    const data = await getDatos("atributos/formatos");
    setFormatosChecks(
      data.filter((formato) => formato.id_tipo_formato !== "6")
    );
  };

  const saveFile = async (id) => {
    try {
      let formData = new FormData();

      formData.append("carpeta", idComponente);
      formData.append("subCarpeta", id);
      formData.append("archivos", fileUpload);

      await setDatos(`atributos/archivos`, formData);
    } catch (err) {
      throw err;
    }
  };

  const saveFileFormatos = async (idOpenData) => {
    const formData = new FormData();
    formData.append("idDatoAbierto", idOpenData);

    if (filesFormatos && filesFormatos.length > 0) {
      await Promise.all(
        filesFormatos.map(async (fileFormato) => {
          formData.set("formato", fileFormato.idFormato);
          formData.set("archivos", fileFormato.file);
          await setDatos(`atributos/archivos/datoAbierto`, formData);
        })
      );
    }
  };

  const saveOpenData = async () => {
    const {
      uuidGeonetWork,
      nombreMetadato,
      descripcion,
      tipoFuente,
      tipoLicencia,
      tematicaDatoAbierto,
      dependenciaDatoAbierto,
      terminosCondDatoAbierto,
      prioridadDatoAbierto,
      formatosDatosAbiertos,
      formatos,
      tieneServicio,
      servicioDatoAbierto,
      diasDatosAbierto,
      colaborativo,
    } = dataDatoAbierto;

    if (
      !uuidGeonetWork ||
      !nombreMetadato ||
      !descripcion ||
      !tipoFuente ||
      !tipoLicencia ||
      !tematicaDatoAbierto ||
      !dependenciaDatoAbierto ||
      !terminosCondDatoAbierto
    ) {
      Alertas({
        title: "",
        html: "<span>Los campos marcados con * son obligatorios.</span>",
        icono: "warning",
      });

      return;
    }

    if (!formatosDatosAbiertos) {
      Alertas({
        title: "",
        html: "<span>Debe seleccionar formatos.</span>",
        icono: "warning",
      });

      return;
    }

    if (tieneServicio) {
      if (
        (!servicioDatoAbierto && !diasDatosAbierto) ||
        diasDatosAbierto === "0"
      ) {
        Alertas({
          title: "",
          html: "<span>Los campos marcados con * son obligatorios.</span>",
          icono: "warning",
        });
        return;
      }
    }

    if (formatosDatosAbiertos) {
      if (formatos.length < 2) {
        Alertas({
          title: "",
          html: "<span>Debe seleccionar por lo menos 2 formatos.</span>",
          icono: "warning",
        });
        return;
      } else {
        if (accion === "Nuevo") {
          if (!tieneServicio && filesFormatos.length !== formatos.length) {
            Alertas({
              title: "",
              html: "<span>Debe subir un archivo por un formato seleccionado.</span>",
              icono: "warning",
            });
            return;
          }
        } else {
          if (!tieneServicio) {
            for (const formato of formatos) {
              let indexFormat = nameFileFormato.findIndex(
                (item) => item.idFormato === formato
              );
              if (indexFormat === -1) {
                Alertas({
                  title: "",
                  html: "<span>Debe subir un archivo por un formato seleccionado.</span>",
                  icono: "warning",
                });
                return;
              }
            }
          }
        }
      }
    }

    if (colaborativo) {
      const { fuenteDatos, fuenteSoftware, fuenteAutor, fuenteInsEm } =
        fuenteColaborativoObject;

      if (!fuenteDatos || !fuenteSoftware || !fuenteAutor || !fuenteInsEm) {
        Alertas({
          title: "",
          html: "<span>Los campos marcados con * son obligatorios.</span>",
          icono: "warning",
        });
        return;
      }
    }

    try {
      setLoadVisible(true);
      if (accion === "Editar") {
        const { data: responseIds } = await updateDatos(
          `opendata/${dataDatoAbierto.idFuenteDato}/${
            !fuenteColaborativoObject.idColaborativo
              ? ""
              : fuenteColaborativoObject.idColaborativo
          }`,
          dataDatoAbierto
        );
        const { idOpenData } = responseIds;

        if (fileUpload) {
          await saveFile(idOpenData);
        }

        if (filesFormatos.length > 0 && idOpenData) {
          await saveFileFormatos(idOpenData);
        }

        // if (dataDatoAbierto.tieneServicio) {
        //   await generarFilesOpenData(idOpenData);
        // }
        Alertas({
          title: "",
          html: "<span>Registro actualizado exitosamente.</span>",
          icono: "success",
        });
        guardarGruposNuevo(idOpenData);

        setLoadVisible(false);
        buscar();
      } else {
        const { data: responseIds } = await setDatos(
          "opendata",
          dataDatoAbierto
        );
        const { idOpenData } = responseIds;

        if (fileUpload) {
          await saveFile(idOpenData);
        }

        if (filesFormatos.length > 0 && idOpenData) {
          await saveFileFormatos(idOpenData);
        }
        guardarGruposNuevo(idOpenData);

        // if (dataDatoAbierto.tieneServicio) {
        //   await generarFilesOpenData(idOpenData);
        // }
        Alertas({
          title: "",
          html: "<span>Registro guardado exitosamente.</span>",
          icono: "success",
        });
        setLoadVisible(false);
      }
      onHide();
    } catch (err) {
      Alertas({
        title: "",
        html: "<span>No se pudo registrar, vuelva a intentarlo.</span>",
        icono: "warning",
      });
      setLoadVisible(false);
    }
  };

  useEffect(() => {
    if (accion === "Editar" && objectEditarDatoAbierto) {
      let datosGrupo = [];
      let datosSubGrupo = [];
      let valorRecorrer = permissions.superAdmin
        ? caractFiltro.resultGruposSubGruposSuperAdmin
        : caractFiltro.resultGruposSubGrupos;
      let idGrupoArray = objectEditarDatoAbierto?.id_grupo.split(",");
      valorRecorrer.map((item) => {
        if (idGrupoArray.includes(item.id_grupo)) {
          datosGrupo.push({ value: item.id_grupo, label: item.nombre });
        }
      });
      caractFiltro.resultSubGruposForm.map((item) => {
        if (idGrupoArray?.includes(item.id_grupo)) {
          datosSubGrupo.push({ value: item.id_grupo, label: item.nombre });
        }
      });
      setFuenteColaborativoObject(
        objectEditarDatoAbierto.id_colaborativo
          ? {
              idColaborativo: objectEditarDatoAbierto.id_colaborativo,
              fuenteDatos: objectEditarDatoAbierto.colaborativo_fuente,
              fuenteSoftware: objectEditarDatoAbierto.colaborativo_software,
              fuenteAutor: objectEditarDatoAbierto.colaborativo_autores,
              fuenteInsEm: objectEditarDatoAbierto.colaborativo_empresa,
            }
          : {}
      );

      let arrayIdFormato = [];

      if (!objectEditarDatoAbierto.id_servicio) {
        let arrayObjectNameFile = [];

        arrayIdFormato = objectEditarDatoAbierto.formatos
          ?.split("/--/")
          ?.map((formato) => {
            let nombreFormato = formato?.split("--")[2];

            let nombreFile = formato?.split("--")[3];

            const idFormato = formatosChecks.find(
              (checkFormato) => checkFormato.nombre === nombreFormato
            )?.id_tipo_formato;

            arrayObjectNameFile.push({
              idFormato: idFormato,
              nameFile: nombreFile,
            });

            return idFormato;
          });

        setNameFileFormato(arrayObjectNameFile);
      } else {
        arrayIdFormato = objectEditarDatoAbierto.formatos
          ?.split("/--/")
          ?.map((formato) => {
            let nombreFormato = formato?.split("--")[2];

            const idFormato = formatosChecks?.find(
              (checkFormato) => checkFormato.nombre === nombreFormato
            )?.id_tipo_formato;

            return idFormato;
          });
      }

      setDataDatoAbierto({
        idFuenteDato: objectEditarDatoAbierto.id_fuente_dato,
        idMetadato: objectEditarDatoAbierto.id_metadata,
        nombreMetadato: objectEditarDatoAbierto.nombre,
        uuidGeonetWork: objectEditarDatoAbierto.metadato_privado,
        descripcion: objectEditarDatoAbierto.descripcion,
        imgOpenData: objectEditarDatoAbierto.imagen,
        fecha_actualizacion: objectEditarDatoAbierto.fecha_actualizacion,
        tipoFuente: objectEditarDatoAbierto.id_tipo_fuente,
        tipoLicencia: objectEditarDatoAbierto.id_tipo_licencia,
        tematicaDatoAbierto: objectEditarDatoAbierto.id_tematica,
        prioridadDatoAbierto: objectEditarDatoAbierto.prioridad,
        dependenciaDatoAbierto: objectEditarDatoAbierto.id_dependencia,
        terminosCondDatoAbierto: objectEditarDatoAbierto.id_termino_condiciones,
        tieneServicio: objectEditarDatoAbierto.id_servicio ? true : false,
        servicioDatoAbierto: objectEditarDatoAbierto.id_servicio,
        urlServicioDatoAbierto: "",
        diasDatosAbierto: objectEditarDatoAbierto.frecuencia,
        formatosDatosAbiertos: objectEditarDatoAbierto.formatos ? true : false,
        formatos: arrayIdFormato,
        fuenteColaborativoData: fuenteColaborativoObject,
        activo: objectEditarDatoAbierto.estado === "1" ? true : false,
        destacado: objectEditarDatoAbierto.destacado ?? false,
        consumible: objectEditarDatoAbierto.consumible ?? false,
        calificacion: objectEditarDatoAbierto.calificacion,
        colaborativo: objectEditarDatoAbierto.id_colaborativo ? true : false,
        deleteChecks: [],
        grupos: datosGrupo,
        subgrupos: datosSubGrupo,
      });

      if (
        objectEditarDatoAbierto?.imagen?.includes(
          "https://www.medellin.gov.co/"
        )
      ) {
        setRutaImg(objectEditarDatoAbierto?.imagen);
      } else {
        setRutaImg(
          `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Datos_abiertos/${objectEditarDatoAbierto?.id_fuente_dato}/${objectEditarDatoAbierto?.imagen}`
        );

        // console.log(rutaImg);
      }
    } else {
      setDataDatoAbierto({
        idMetadato: null,
        nombreMetadato: "",
        uuidGeonetWork: "",
        imgOpenData: "",
        descripcion: "",
        fecha_actualizacion: "",
        tipoFuente: null,
        tipoLicencia: null,
        tematicaDatoAbierto: null,
        prioridadDatoAbierto: "",
        dependenciaDatoAbierto: null,
        terminosCondDatoAbierto: null,
        tieneServicio: false,
        servicioDatoAbierto: null,
        urlServicioDatoAbierto: "",
        diasDatosAbierto: 0,
        formatosDatosAbiertos: false,
        formatos: [],
        fuenteColaborativoData: fuenteColaborativoObject,
        activo: false,
        destacado: false,
        calificacion: false,
        colaborativo: false,
        deleteChecks: [],
        grupos: [],
        subgrupos: [],
      });

      setFuenteColaborativoObject({});

      setfileUpload(null);

      setRutaImg("");
    }
    setFilesFormatos([]);
  }, [show]);

  useEffect(() => {
    setDataDatoAbierto((prev) => ({
      ...prev,
      fuenteColaborativoData: fuenteColaborativoObject,
    }));
  }, [fuenteColaborativoObject]);

  useEffect(() => {
    listarNombreMetadato();
    listarCombos();
    listarFormatos();
  }, []);

  async function handleClickGenerarFiles(idfuente) {
    try {
      setLoadVisible(true);
      await generarFilesOpenData(idfuente);
      setLoadVisible(false);
    } catch (error) {
      console.error(error);
      setLoadVisible(false);
    }
    setLoadVisible(false);
  }

  const handleChangeGrupos = ({ nombreCombo, valor, tipo }) => {
    if (tipo === "1") {
      let valorComparar = valor.map((val) => val.value);
      let resultSubGruposcp = caractFiltro.resultSubGruposForm.filter((item) =>
        valorComparar.includes(item.id_grupo_padre)
      );
      setTipofiltroSubGruposFiltrada(resultSubGruposcp);
      let dataDatoAbiertocp = { ...dataDatoAbierto };
      dataDatoAbiertocp.subgrupos = dataDatoAbierto.subgrupos?.filter((item) =>
        valorComparar.includes(item.value_parent)
      );
      dataDatoAbiertocp[nombreCombo] = valor;
      setDataDatoAbierto(dataDatoAbiertocp);
    } else {
      setDataDatoAbierto({
        ...dataDatoAbierto,
        [nombreCombo]: valor,
      });
    }
  };

  async function guardarGruposNuevo(idModulo) {
    let gruposUnificados = dataDatoAbierto.grupos.concat(
      dataDatoAbierto.subgrupos
    );

    const jsonGrupos = {
      id_modulo: idModulo,
      grupos: gruposUnificados.map((val) => val.value),
      modulo: "datos_abiertos",
    };
    const respuesta = await setDatosGrupos(`geomed/grupos/agregar`, jsonGrupos);
  }

  return (
    <>
      <Load visible={loadVisible} />
      <Modal
        show={show}
        onHide={onHide}
        size="md"
        id="modalAdminRegister"
        scrollable={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>{tituloModal}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="pb-2">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">
                  Nombre <strong>*</strong>
                </Form.Label>
                <ReactSelect
                  data={metadatos.map((metadato) => {
                    return {
                      value: metadato.id,
                      label: metadato.nombreMetadato,
                    };
                  })}
                  nameCombo={"idMetadato"}
                  selectedValue={dataDatoAbierto.idMetadato}
                  key={dataDatoAbierto.idMetadato}
                  handleChange={handleChangeReactSelect}
                  placeholder={"Seleccione..."}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">
                  Geonetwork <strong>*</strong>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="geonetwork"
                  disabled={true}
                  value={dataDatoAbierto.uuidGeonetWork}
                  className="inputs-forms-admin focus-admin-register"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">
                  Descripción <strong>*</strong>
                </Form.Label>
                <Form.Control
                  name="descripcion"
                  as="textarea"
                  disabled={true}
                  value={dataDatoAbierto.descripcion}
                  className="inputs-forms-admin focus-admin-register textarea-form-admin"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">
                  Tipo Fuente <strong>*</strong>
                </Form.Label>
                <TipoFuente
                  tipoFuente={dataDatoAbierto.tipoFuente}
                  handleChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">
                  Tipo licencia <strong>*</strong>
                </Form.Label>
                <TipoLicencia
                  tipoLicencia={dataDatoAbierto.tipoLicencia}
                  handleChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">
                  Temática <strong>*</strong>
                </Form.Label>
                <Tematicas
                  caractFiltro={caractFiltro}
                  element={idComponente}
                  handleChange={handleChange}
                  nameCombo={"tematicaDatoAbierto"}
                  idTematica={dataDatoAbierto.tematicaDatoAbierto}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">
                  Dependencia <strong>*</strong>
                </Form.Label>
                <Dependencias
                  handleChange={handleChange}
                  nameCombo={"dependenciaDatoAbierto"}
                  idDependencia={dataDatoAbierto.dependenciaDatoAbierto}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">
                  Terminos y condiciones <strong>*</strong>
                </Form.Label>
                <TerminosCondiciones
                  handleChange={handleChange}
                  nameCombo={"terminosCondDatoAbierto"}
                  idTermino={dataDatoAbierto.terminosCondDatoAbierto}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">Prioridad</Form.Label>
                <Form.Control
                  type={"text"}
                  value={dataDatoAbierto.prioridadDatoAbierto}
                  className="inputs-forms-admin focus-admin-register"
                  name={"prioridadDatoAbierto"}
                  min={1}
                  maxLength={25}
                  onChange={handleChangePrioridad}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">Grupo</Form.Label>
                <GruposSubgrupos
                  caractFiltro={caractFiltro}
                  handleChange={handleChangeGrupos}
                  nombreCombo={"grupos"}
                  tipoConsulta={"1"}
                  tipofiltroSubGruposFiltrada={tipofiltroSubGruposFiltrada}
                  datosEditar={dataDatoAbierto.grupos}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="label-forms-admin">Subgrupo</Form.Label>
                <GruposSubgrupos
                  caractFiltro={caractFiltro}
                  handleChange={handleChangeGrupos}
                  nombreCombo={"subgrupos"}
                  tipoConsulta={"2"}
                  tipofiltroSubGruposFiltrada={tipofiltroSubGruposFiltrada}
                  datosEditar={dataDatoAbierto.subgrupos}
                />
              </Form.Group>
              <DropZoneFile
                extensiones={{
                  "image/*": [],
                }}
                tipoFile={"Imagen"}
                config={{
                  icon: (
                    <AiOutlinePicture
                      color="#2E2E2E"
                      size={"25px"}
                      className="mb-2"
                    />
                  ),
                  message: "Arrastre o da clic para subir la imagen",
                }}
                onNewFile={handleFileUpload}
                rutaEdit={rutaImg}
                size={10}
              />
              <Form.Group className="mb-1">
                <div className="container-checks-admin">
                  <Form.Label className="label-forms-admin me-2" title="Activo">
                    Activo
                  </Form.Label>
                  <Form.Check
                    type="switch"
                    name="activo"
                    className="check-geomedellin"
                    key={"activoDatoColaborativo"}
                    checked={dataDatoAbierto.activo}
                    onChange={handleChange}
                  />

                  <Form.Label
                    className="label-forms-admin me-2"
                    title="Destacado"
                  >
                    Destacado
                  </Form.Label>
                  <Form.Check
                    type="switch"
                    name="destacado"
                    className="check-geomedellin"
                    key={"destacadoDatoColaborativo"}
                    checked={dataDatoAbierto.destacado}
                    onChange={handleChange}
                  />

                  <Form.Label
                    className="label-forms-admin me-2"
                    title="Calificación"
                  >
                    Calificación
                  </Form.Label>
                  <Form.Check
                    type="switch"
                    className="check-geomedellin"
                    name="calificacion"
                    key={"calificacionDatoColaborativo"}
                    checked={dataDatoAbierto.calificacion}
                    onChange={handleChange}
                  />
                  <Form.Label
                    className="label-forms-admin me-2"
                    title="Habilitado para API"
                  >
                    Habilitado para API
                  </Form.Label>
                  <Form.Check
                    type="switch"
                    name="consumible"
                    className="check-geomedellin"
                    key={"consumibleDatoColaborativo"}
                    checked={dataDatoAbierto.consumible}
                    onChange={handleChange}
                  />
                </div>
              </Form.Group>
              <Form.Group className="mb-3">
                <div className="container-checks-admin">
                  <Form.Label
                    className="label-forms-admin me-1"
                    title="¿Tiene servicio?"
                  >
                    ¿Tiene servicio?
                  </Form.Label>
                  <Form.Check
                    type="switch"
                    className="check-geomedellin"
                    name={"tieneServicio"}
                    key={"tieneServicio"}
                    checked={dataDatoAbierto.tieneServicio}
                    onChange={handleChange}
                  />
                  <Form.Label
                    className="label-forms-admin me-1"
                    title="Fuente colaborativo"
                  >
                    Fuente colaborativo
                  </Form.Label>
                  <Form.Check
                    type="switch"
                    className="check-geomedellin"
                    name={"colaborativo"}
                    onChange={handleChangeColaborativo}
                    checked={dataDatoAbierto.colaborativo}
                  />
                </div>
              </Form.Group>

              <Collapse in={dataDatoAbierto.tieneServicio} className="mb-4">
                <div id="example-collapse-text">
                  <Row>
                    <Col>
                      <Form.Group className="mb-2">
                        <Form.Label className="label-forms-admin">
                          Servicio <strong>*</strong>
                        </Form.Label>
                        <ReactSelect
                          data={servicios.map((servicio) => {
                            return {
                              value: servicio.id_servicio,
                              label: servicio.nombre,
                            };
                          })}
                          nameCombo={"servicioDatoAbierto"}
                          selectedValue={dataDatoAbierto.servicioDatoAbierto}
                          handleChange={handleChangeReactSelect}
                          placeholder={"Seleccione..."}
                          size="small"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-2">
                        <Form.Label className="label-forms-admin">
                          Frecuencia (días) <strong>*</strong>
                        </Form.Label>
                        <Form.Select
                          className="inputs-forms-admin focus-admin-register"
                          name="diasDatosAbierto"
                          onChange={handleChange}
                          value={dataDatoAbierto.diasDatosAbierto}
                        >
                          <option value={"0"} selected>
                            Seleccione...
                          </option>
                          {diasFrecuencia.map((e, i) => {
                            // <option selected>Seleccione...</option>;
                            return (
                              <option
                                key={e.id_frecuencia}
                                value={e.id_frecuencia}
                              >
                                {e.descripcion}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Collapse>
              <Form.Group className="mb-2 cursor-pointer">
                <div
                  className="container-formatos-admin-opendata"
                  onClick={handleFormatos}
                >
                  <Form.Label className="label-forms-admin" id="label-formato">
                    Formatos
                  </Form.Label>
                  <hr className="hr-formatos-opendata" />
                  {!dataDatoAbierto.formatosDatosAbiertos ? (
                    <IoIosArrowDown color="#2E2E2E" />
                  ) : (
                    <IoIosArrowUp color="#2E2E2E" />
                  )}
                </div>
              </Form.Group>
              <Collapse
                in={dataDatoAbierto.formatosDatosAbiertos}
                className="mb-2"
                timeout={89090}
              >
                <div id="example-collapse-text" className="collapse-openData">
                  {formatosChecks.map((formato, index) => {
                    return (
                      <div
                        key={formato.id_tipo_formato}
                        className={`flex-container_formatos ${
                          index !== 0 ? "mt-3" : ""
                        }`}
                      >
                        <Form.Check
                          className="check-geomedellin"
                          name={"formatos"}
                          value={formato.id_tipo_formato}
                          onChange={handleChangeFormatosChecks}
                          checked={dataDatoAbierto.formatos?.includes(
                            formato.id_tipo_formato
                          )}
                        />
                        <Form.Label className="label-forms-admin">
                          {formato.nombre}
                        </Form.Label>
                        {!dataDatoAbierto.tieneServicio ? (
                          formato.descarga &&
                          dataDatoAbierto.formatos?.includes(
                            formato.id_tipo_formato
                          ) ? (
                            <div className="flex-file_adjunt">
                              <input
                                type={"file"}
                                className={"file-adjunt"}
                                accept={".zip"}
                                id={`input-file_formatos_${formato.id_tipo_formato}`}
                                onChange={(e) => {
                                  handleChangeFormatoFile(
                                    e,
                                    formato.id_tipo_formato
                                  );
                                }}
                              />
                              <div className="flex-text_file">
                                <label
                                  for={`input-file_formatos_${formato.id_tipo_formato}`}
                                  id={`label-formato_file_${formato.id_tipo_formato}`}
                                  className="label-text_file"
                                >
                                  {accion === "Editar"
                                    ? nameFileFormato?.find(
                                        (name) =>
                                          name.idFormato ===
                                          formato.id_tipo_formato
                                      )?.nameFile
                                    : "Seleccione un archivo"}
                                </label>
                              </div>
                              <div className="flex-button_fileFormato">
                                <Button
                                  className="btn-geomedellin_adjuntar focus-none"
                                  value={formato.id_tipo_formato}
                                  onClick={handleClickInputFileFormato}
                                >
                                  Adjuntar
                                </Button>
                              </div>
                            </div>
                          ) : dataDatoAbierto.formatos.includes(
                              formato.id_tipo_formato
                            ) ? (
                            <Form.Control
                              type="text"
                              name=""
                              className="inputs-forms-admin focus-admin-register"
                            />
                          ) : null
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              </Collapse>
              <Collapse in={dataDatoAbierto.colaborativo}>
                <div id="example-collapse-text">
                  <Form.Group className="mb-3">
                    <Form.Label className="label-forms-admin">
                      Datos abiertos utilizados / Fuente conjunto datos{" "}
                      <strong>*</strong>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="inputs-forms-admin focus-admin-register"
                      onChange={handleChangeFuenteColabo}
                      name={"fuenteDatos"}
                      value={fuenteColaborativoObject?.fuenteDatos}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label className="label-forms-admin">
                      Software utilizado <strong>*</strong>
                    </Form.Label>
                    <SoftwareUtilizado
                      handleChange={handleChangeFuenteColabo}
                      idSoftware={fuenteColaborativoObject?.fuenteSoftware}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label className="label-forms-admin">
                      Autor (es) <strong>*</strong>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="inputs-forms-admin focus-admin-register"
                      onChange={handleChangeFuenteColabo}
                      name={"fuenteAutor"}
                      value={fuenteColaborativoObject?.fuenteAutor}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label className="label-forms-admin">
                      Institución / Empresa <strong>*</strong>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="inputs-forms-admin focus-admin-register"
                      onChange={handleChangeFuenteColabo}
                      name={"fuenteInsEm"}
                      value={fuenteColaborativoObject?.fuenteInsEm}
                    />
                  </Form.Group>
                </div>
              </Collapse>
              <div className="container-accion-admin-button gap-20">
                <Button
                  className="btn-geomedellin btn-register-admin btn-accion"
                  onClick={saveOpenData}
                >
                  Guardar
                </Button>
                {accion === "Editar" && dataDatoAbierto.tieneServicio ? (
                  <Button
                    className="btn-geomedellin btn-register-admin btn-accion"
                    onClick={() =>
                      handleClickGenerarFiles(dataDatoAbierto.idFuenteDato)
                    }
                  >
                    Generar formatos
                  </Button>
                ) : (
                  ""
                )}
              </div>
            </Form>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};
